module.exports = (__webpack_require__(/*! dll-reference react_runtime */ "dll-reference react_runtime"))("./node_modules/react-redux/es/index.js");